const FormValidator = (function (Utils) {

    return {
        init: function (form, config) {
            $('body').on('submit', form, function (e) {
                e.preventDefault();

                window.LoadingScreen.show();

                let form = $(this);
                let formData = form.serializeJSON();

                //let formData = form.serializeJSON();
                let formResult = form.find('.form-result');
                let formMethod = form.attr('method');
                let submitButton = form.find('[type="submit"]');

                let method = form.find('[name="_method"]');

                if (method.length) {
                    formMethod = method.val()
                }


                form.find('.invalid-feedback').slideUp().remove();
                form.find('.form-group').removeClass('is-invalid');
                form.find('.input-group').removeClass('is-invalid');
                form.find('.cke').removeClass('is-invalid');
                form.find('input, select').removeClass('is-invalid');
                form.find('input, select, .select2-selection').removeClass('is-invalid-select2');
                form.find('.nav-tabs .nav-link').removeClass('text-danger');


                submitButton.prop('disabled', true).attr('disabled', true).addClass('disabled');

                $.ajaxSetup({headers: {'X-CSRF-TOKEN': $(document).find('meta[name="csrf-token"]').attr('content')}});

                if (config !== undefined && config.hasOwnProperty('beforeSending') && Utils.isFunction(config.beforeSending)) {
                    config.beforeSending(formData);
                }

                if (config !== undefined && config.hasOwnProperty('delayFormExecutionUntil') && Utils.isFunction(config.delayFormExecutionUntil)) {
                    config.delayFormExecutionUntil(formData);

                    if (window.delayFormExecutionUntil === true) {
                        setTimeout(function() {
                            form.submit();
                            return false;
                        }, 1000);

                        return false;
                    }
                }

                if (config !== undefined && config.hasOwnProperty('processDataBeforeSending') && Utils.isFunction(config.processDataBeforeSending)) {
                    formData = config.processDataBeforeSending(formData);
                }

                let request = $.ajax({
                    type: formMethod,
                    dataType: 'json',
                    url: form.attr('action'),
                    data: formData,
                    //processData: false,
                    //contentType: false,
                });

                request.done(function (data) {
                    if (data.hasOwnProperty('success') && data.success === true) {
                        if (config !== undefined && config.hasOwnProperty('successCallback') && Utils.isFunction(config.successCallback)) {
                            config.successCallback(data, formData);
                        }

                        let successTitle = data.hasOwnProperty('successTitle') ? data.successTitle : 'Gespeichert';

                        window.Notifier.success(successTitle);

                        let resetAfterSubmitTime = 2000;
                        if (data.hasOwnProperty('resetAfterSubmitTime')) {
                            resetAfterSubmitTime = data.resetAfterSubmitTime;
                        }

                        setTimeout(function () {
                            if (form.hasClass('resetAfterSubmit') || data.hasOwnProperty('resetAfterSubmit') && data.resetAfterSubmit === true) {
                                form.trigger("reset");
                                form[0].reset();
                            }

                        }, resetAfterSubmitTime);


                        //$('html, body').animate({scrollTop: form.find('.form-result').offset().top - 300}, 1000);

                        if (data.hasOwnProperty('redirect')) {
                            let redirectTime = 800;

                            if (data.hasOwnProperty('redirectTime')) {
                                redirectTime = data.redirectTime;
                            }

                            setTimeout(function () {
                                window.location = data.redirect;
                                window.LoadingScreen.hide();
                            }, redirectTime);
                        }
                        else {
                            window.LoadingScreen.hide();
                        }
                    } else {
                        if (config !== undefined && config.hasOwnProperty('errorCallback') && Utils.isFunction(config.errorCallback)) {
                            config.errorCallback(data, formData);
                        }

                        window.LoadingScreen.hide();
                    }

                    if (!data.hasOwnProperty('redirect')) {
                        submitButton.prop('disabled', false).removeAttr('disabled').removeClass('disabled');
                    }
                });

                request.fail(function (jqXHR, textStatus, error) {
                    let response = jqXHR.responseJSON;

                    if (config !== undefined && config.hasOwnProperty('errorCallback') && Utils.isFunction(config.errorCallback)) {
                        config.errorCallback(response);
                    }

                    if (response.hasOwnProperty('errors')) {
                        $.each(response.errors, function (i, v) {
                            let msg = '<span class="invalid-feedback"><strong>' + v + '</strong></span>';

                            if (i.split('.').length === 2) {
                                let partials = i.split('.');
                                i = partials[0] + '[' + partials[1] + ']';
                            }

                            if (i.split('.').length === 3) {
                                let partials = i.split('.');
                                i = partials[0] + '[' + partials[1] + ']' + '[' + partials[2] + ']';
                            }

                            if (i.split('.').length === 4) {
                                let partials = i.split('.');
                                i = partials[0] + '[' + partials[1] + ']' + '[' + partials[2] + ']' + '[' + partials[3] + ']';
                            }

                            if (i.split('.').length === 5) {
                                let partials = i.split('.');
                                i = partials[0] + '[' + partials[1] + ']' + '[' + partials[2] + ']' + '[' + partials[3] + ']' + '[' + partials[4] + ']';
                            }

                            let defaultInput = $(document).find('input[name="' + i + '"], textarea[name="' + i + '"]');

                            let tabPane = defaultInput.closest('.tab-pane');

                            if (tabPane.length)
                            {
                                let paneId = tabPane.attr('id');
                                let navLink = $('.nav-tabs .nav-link[href="#' + paneId + '"]');

                                navLink.addClass('text-danger');
                                //navLink.parents('.nav-item').addClass('tab-error');
                            }


                            if (defaultInput.hasClass('custom-ckeditor')) {
                                defaultInput
                                    .addClass('is-invalid')
                                    .parent('.form-group')
                                    .addClass('is-invalid').find('.cke').addClass('is-invalid').after(msg);
                            }

                            if (defaultInput.parent('.form-group').length && !defaultInput.hasClass('custom-ckeditor')) {
                                defaultInput
                                    .after(msg)
                                    .addClass('is-invalid')
                                    .parent('.form-group')
                                    .addClass('is-invalid');
                            }


                            if (defaultInput.parent('.input-group').length) {
                                defaultInput
                                    .addClass('is-invalid')
                                    .parent('.input-group')
                                    .addClass('is-invalid')
                                    .after(msg);
                            }


                            let selectInputMultiple = $(document).find('select[name="' + i + '[]"]');

                            if (selectInputMultiple.hasClass('select2') || selectInputMultiple.hasClass('select2Item') || selectInputMultiple.hasClass('select2Tags') || selectInputMultiple.hasClass('select2Custom') || selectInputMultiple.hasClass('select2Handler')
                            ) {
                                selectInputMultiple
                                    .addClass('is-invalid')
                                    .parents('.form-group')
                                    .addClass('is-invalid')
                                    .find('.select2-container')
                                    .after(msg);

                                selectInputMultiple
                                    .parents('.form-group')
                                    .find('.select2-selection')
                                    .addClass('is-invalid-select2');
                            }

                            let selectInputDefault = $(document).find('select[name="' + i + '"]');


                            if (1 || selectInputDefault.hasClass('select2') || selectInputDefault.hasClass('select2Item') || selectInputDefault.hasClass('select2Tags') || selectInputDefault.hasClass('select2Custom')  || selectInputDefault.hasClass('select2Handler')
                            ) {

                                selectInputDefault
                                    .after(msg)
                                    .addClass('is-invalid')
                                    .parent('.form-group')
                                    .addClass('is-invalid');
                            }
                        });

                        let keys = Object.keys(response.errors);
                        let set_focus = $(document).find('input[name="' + keys[0] + '"], select[name="' + keys[0] + '"], textarea[name="' + keys[0] + '"]');

                        let custom_error = 'Technischer Fehler!';

                        if (response.hasOwnProperty('custom_error')) {

                            custom_error = response.custom_error.errorTitle;
                        }
                        if (response.hasOwnProperty('errors') && response.errors.hasOwnProperty('custom_error') && response.errors.custom_error.hasOwnProperty('errorTitle')) {

                            custom_error = response.errors.custom_error.errorTitle;
                        }

                        /*
                        formResult
                            .addClass('open-alert')
                            .addClass('alert-important')
                            .addClass('bg-danger')
                            .slideDown()
                            .html(custom_error);
                         */

                        window.Notifier.error(custom_error);

                        set_focus.focus()
                    }

                    if (response.hasOwnProperty('error') && !response.hasOwnProperty('errors')) {
                        window.Notifier.error(response.error, {timeout: 4000});
                    }

                    submitButton.prop('disabled', false).removeAttr('disabled').removeClass('disabled');
                    window.LoadingScreen.hide();
                });
            });
        }
    };
})(Utils);

window.FormValidator = FormValidator;
